import type React from 'react';
import { graphql } from 'react-apollo';

import { compose } from 'recompose';

import S12nMembershipQuery from 'bundles/s12n-enroll/api/OnDemandSpecializationMembership.graphql';
import type {
  OnDemandSpecializationMembershipQuery,
  OnDemandSpecializationMembershipQueryVariables,
  OnDemandSpecializationMembership_S12nMembershipFragment as S12nMembership,
} from 'bundles/s12n-enroll/api/__generated__/OnDemandSpecializationMembership';

import type { OnDemandSpecializationMembershipRole } from './__generated__/globalTypes';

export type InputProps = {
  userId: number;
  role?: OnDemandSpecializationMembershipRole;
};

export type S12nMemberships = S12nMembership[];

export type PropsFromS12nMembershipQuery = {
  loading: boolean;
  s12nMemberships: S12nMemberships;
};

const withS12nMembershipData = <PropsFromCaller extends InputProps>(
  WrappedComponent: React.ComponentType<PropsFromCaller & PropsFromS12nMembershipQuery>
) =>
  compose<PropsFromCaller & PropsFromS12nMembershipQuery, PropsFromCaller>(
    graphql<
      PropsFromCaller,
      OnDemandSpecializationMembershipQuery,
      OnDemandSpecializationMembershipQueryVariables,
      PropsFromS12nMembershipQuery
    >(S12nMembershipQuery, {
      options: ({ userId, role }) => ({
        variables: {
          userId,
          role,
        },
        context: { clientName: 'gatewayGql' },
      }),
      props: ({ data }) => {
        return {
          loading: data?.loading || false,
          s12nMemberships: data?.OnDemandSpecializationMembership?.membershipsByUser ?? [],
        };
      },
    })
  )(WrappedComponent);

export default withS12nMembershipData;
